import "./homeDiscrA.css";

import TestImage from "./homepage_images/home-images/profile1.jpg";

const HomeDiscrA = () => {
  const stats = [
    {
      title: "Operational Efficiency",
      value: "Optimized",
      text: "Designed to simplify complex workflows and help businesses operate with greater speed, accuracy, and confidence.",
      featured: true,
    },
    {
      title: "Multi-Location Management",
      value: "Built-In",
    },
    {
      title: "Real-Time Inventory Intelligence",
      value: "Always On",
    },
    {
      title: "Smarter Business Decisions",
      value: "Data-Driven",
    },
  ];

  return (
    <section className="homeDiscrA">
      <div className="homeDiscrAWrapper">
        {/* =====================================================
            LEFT — BRAND / TRUST PANEL
        ====================================================== */}

        <aside className="homeDiscrALeft">
          <div className="homeDiscrAStatus fx-ac space">
            <span className="homeDiscrABadge"></span>

            <span>Endless Possibilities</span>
          </div>

          <div className="homeDiscrALeftMiddle">
            <span className="homeDiscrAOnline">100% Online</span>

            <div className="homeDiscrAOnlineLine"></div>

            <div className="homeDiscrAAvatars fx-ac">
              <img src={TestImage} alt="Universe Inventory customer" />

              <img src={TestImage} alt="Universe Inventory customer" />

              <img src={TestImage} alt="Universe Inventory customer" />

              <span className="homeDiscrAAvatarMore">+</span>
            </div>

            <p>
              Join thousands of businesses worldwide that trust Universe
              Inventory to manage their inventory, streamline operations, and
              drive growth.
            </p>
          </div>

          <div className="homeDiscrALeftBottom">
            <button className="homeDiscrABtn">
              <span>Get Started</span>
              <span className="homeDiscrABtnArrow">↗</span>
            </button>

            <span className="homeDiscrASecure">
              Secure · Cloud-based · Built to scale
            </span>
          </div>
        </aside>

        {/* =====================================================
            RIGHT — PLATFORM STORY
        ====================================================== */}

        <div className="homeDiscrARight">
          <div className="homeDiscrAHeading">
            <span className="homeDiscrASectionNumber">01 — THE PLATFORM</span>

            <h2>
              Connect Your Inventory,
              <span> Streamline Operations </span>& Accelerate Growth
            </h2>

            <p>
              At Universe Inventory, we believe businesses perform at their best
              when every product, transaction, location, and decision is
              connected. Our intelligent inventory management platform brings
              your operations together in one centralized ecosystem, giving you
              the visibility and control to manage stock with precision,
              streamline everyday processes, and respond to your business in
              real time.
            </p>
          </div>

          {/* =====================================================
              CAPABILITY CARDS
          ====================================================== */}

          <div className="homeDiscrAStats">
            {stats.map((item, index) => (
              <article
                key={index}
                className={`homeDiscrACard ${item.featured ? "featured" : ""}`}
              >
                <div className="homeDiscrACardTop">
                  <span className="homeDiscrACardNumber">0{index + 1}</span>

                  <span className="homeDiscrACardDot"></span>
                </div>

                <h4>{item.title}</h4>

                <div className="homeDiscrACardBottom">
                  <h3>{item.value}</h3>

                  {item.text && <p>{item.text}</p>}

                  <span className="homeDiscrACardArrow">↗</span>
                </div>
              </article>
            ))}
          </div>

          {/* =====================================================
              BOTTOM PLATFORM STATEMENT
          ====================================================== */}

          <div className="homeDiscrABottom">
            <div className="homeDiscrABottomNumber">
              <span>04</span>
            </div>

            <p>
              From inventory and warehouses to point of sale, customers,
              suppliers, reporting, and multi-location operations, Universe
              Inventory gives growing businesses the tools they need to operate
              efficiently, reduce complexity, and scale with confidence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeDiscrA;
